import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IPublishRequestPayload } from '@app-store/slices/editList/publishList'
import { history } from '@components/App'
import routes from '@utils/constants/routes'

interface TaskAction extends Action {
    payload: IPublishRequestPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.editList.publishList

function* publishListSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/companies/edit-lists/publish/${payload.id}`, { ...payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'List has been published successfully.'
            })
            history.replace(routes.directory.assigned._)
            yield put(rootActions.ui.directory.onSelectRows([]))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* publishListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, publishListSagaTask)
}

export default publishListSaga
